import React, { useEffect } from 'react';
import { useProduct, useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import Banner from './componentsV2/Banner';
import PowerSolution from './componentsV2/PowerSolution';
import TabImgs from './componentsV2/TabImgs';
import OnePicture from './componentsV2/OnePicture';
import NavPage from './componentsV2/NavPage';
import TabSwiper from './componentsV2/TabSwiper';
import CompareSelector from './componentsV2/CompareSelector';
import Screen1 from './componentsV2/Screen1';
import Screen2 from './componentsV2/Screen2';
import Screen3 from './componentsV2/Screen3';
import Screen4 from './componentsV2/Screen4';
import Screen5 from './componentsV2/Screen5';
import Screen6 from './componentsV2/Screen6';
import Screen7 from './componentsV2/Screen7';
import Screen8 from './componentsV2/Screen8';
import N from './componentsV2/N';
import './css/jp_v2.scss';

const JP_Product_V2: React.FC = ({}) => {
    const { pageStatus } = useProductStore();
    const { dispatch } = useProduct();

    /** 检测浏览器是否支持使用 webp */
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const webP = new Image();
        webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
        webP.onload = () => {
            dispatch({
                type: 'changeCanWebp',
                payload: 1,
            });
        };
        webP.onerror = () => {
            dispatch({
                type: 'changeCanWebp',
                payload: -1,
            });
        };
    }, [dispatch]);
    return (
        <>
            <Banner />
            <PowerSolution />
            <TabImgs />
            <OnePicture />
            {pageStatus === IPageStatus.statusD && <NavPage />}
            {pageStatus === IPageStatus.statusD && <Screen1 />}
            {pageStatus === IPageStatus.statusD && <Screen2 />}
            {pageStatus === IPageStatus.statusD && <Screen3 />}
            {pageStatus === IPageStatus.statusC && <Screen4 />}
            {pageStatus === IPageStatus.statusC && <Screen5 />}
            <Screen6 />
            <Screen7 />
            <Screen8 />
            <TabSwiper />
            <CompareSelector />
            <N />
        </>
    );
};
export default JP_Product_V2;
